(function () {
  var cart = document.querySelector('.custom-cart');
  if (!cart) return;

  function changeLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function () {
      window.location.reload();
    });
  }

  cart.querySelectorAll('[data-cart-decrease]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var line = btn.dataset.line;
      var input = cart.querySelector('[data-cart-qty-input][data-line="' + line + '"]');
      var newQty = Math.max(0, (parseInt(input.value, 10) || 1) - 1);
      changeLine(line, newQty);
    });
  });

  cart.querySelectorAll('[data-cart-increase]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var line = btn.dataset.line;
      var input = cart.querySelector('[data-cart-qty-input][data-line="' + line + '"]');
      var newQty = (parseInt(input.value, 10) || 1) + 1;
      changeLine(line, newQty);
    });
  });

  cart.querySelectorAll('[data-cart-qty-input]').forEach(function (input) {
    input.addEventListener('change', function () {
      var line = input.dataset.line;
      var newQty = Math.max(0, parseInt(input.value, 10) || 1);
      changeLine(line, newQty);
    });
  });

  cart.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      changeLine(btn.dataset.line, 0);
    });
  });
})();